import { Injectable } from '@angular/core';
import { InMemoryDbService } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';
import { UsersTable } from './fake-db/users.table';
import { VersionesTable } from './fake-db/versiones.table';
import { ProductosTable } from './fake-db/productos.table';
import { ProductoVersionsTable } from './fake-db/productoVersions.table';
//import { ECommerceDataContext } from '../modules/e-commerce/_fake/fake-server/_e-commerce.data-context';

@Injectable({
  providedIn: 'root',
})
export class FakeAPIService implements InMemoryDbService {
  constructor() { }

  /**
   * Create Fake DB and API
   */
  createDb(): {} | Observable<{}> {
    // tslint:disable-next-line:class-name
    const db = {
      // auth module
      users: UsersTable.users,
      versiones: VersionesTable.versiones,
      productos: ProductosTable.productos,
      productoVersion: ProductoVersionsTable.productoVersions
    };
    return db;
  }
}
